/**
 * @generated SignedSource<<75143ab84487dc8e32b7ef039c623475>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type updatePageHydrantFamilyQuery$variables = {
  hydrantFamilyId: string;
};
export type updatePageHydrantFamilyQueryVariables = updatePageHydrantFamilyQuery$variables;
export type updatePageHydrantFamilyQuery$data = {
  readonly hydrantFamily: {
    readonly id: string;
    readonly createdAt: any;
    readonly name: string;
    readonly manufacturer: {
      readonly id: string;
      readonly name: string;
    };
  } | null;
};
export type updatePageHydrantFamilyQueryResponse = updatePageHydrantFamilyQuery$data;
export type updatePageHydrantFamilyQuery = {
  variables: updatePageHydrantFamilyQueryVariables;
  response: updatePageHydrantFamilyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hydrantFamilyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "hydrantFamilyId",
    "variableName": "hydrantFamilyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageHydrantFamilyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HydrantFamily",
        "kind": "LinkedField",
        "name": "hydrantFamily",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "manufacturer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageHydrantFamilyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "HydrantFamily",
        "kind": "LinkedField",
        "name": "hydrantFamily",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "manufacturer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5851b8d53e892e10bc27dbadbc121edc",
    "id": null,
    "metadata": {},
    "name": "updatePageHydrantFamilyQuery",
    "operationKind": "query",
    "text": "query updatePageHydrantFamilyQuery(\n  $hydrantFamilyId: ID!\n) {\n  hydrantFamily(hydrantFamilyId: $hydrantFamilyId) {\n    id\n    createdAt\n    name\n    manufacturer {\n      __typename\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f98847f1a2ac3204d19896cf71b6ef7";

export default node;
